import request from '../utils/http'
// 用户列表
export function index (query) {
  return request({
    url: '/logs/index',
    method: 'GET',
    params: query
  })
}
// 用户详情
export function detail (query) {
  return request({
    url: '/logs/detail',
    method: 'GET',
    params: query
  })
}
// 用户开关
export function show (query) {
  return request({
    url: '/logs/show',
    method: 'POST',
    data: query
  })
}
// 导出
export function exportApi (query) {
  return request({
    url: '/logs/export',
    method: 'POST',
    data: query,
    responseType: 'blod'
  })
}



// WEBPACK FOOTER //
// ./src/api/logs.js